import { apiRequest } from "../api/apiService";

export const loginUser = async (mobile, pin) => {
    const params = new URLSearchParams();

    params.append("grant_type", "password");
    params.append("username", mobile);
    params.append("password", pin);

    console.log("📤 Login API payload (FORM):", params.toString());

    return apiRequest({
        method: "POST",
        url: "/token",
        data: params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};




export const sendOtp = async (MobileNo) => {
    return apiRequest({
        method: "POST",
        url: "/account/send-otp",
        data: { MobileNo },
    });
};


export const registerUser = async (userData) => {
    return apiRequest({
        method: "POST",
        url: "/account/group-registration",
        data: userData,
    });
};

export const resetPin = async (payload) => {
    return apiRequest({
        method: "POST",
        url: "/account/reset_forgot_pin",
        data: payload,
    });
};

export const refreshToken = async (rToken) => {
    const params = new URLSearchParams();
    params.append("grant_type", "refresh_token");
    params.append("refresh_token", rToken);

    return apiRequest({
        method: "POST",
        url: "/token",
        data: params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};



